import { render, staticRenderFns } from "./ScoreCardGitHubWithNarrative.vue?vue&type=template&id=78fec288&scoped=true&"
import script from "./ScoreCardGitHubWithNarrative.vue?vue&type=script&lang=js&"
export * from "./ScoreCardGitHubWithNarrative.vue?vue&type=script&lang=js&"
import style0 from "./ScoreCardGitHubWithNarrative.vue?vue&type=style&index=0&id=78fec288&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fec288",
  null
  
)

export default component.exports